import { createNotification } from "@/platform/bridge/envelope"
import { type NativeBridge, isAppBridgeAvailable, postRawToNativeHost, postToNativeHost } from "@/platform/bridge/use-native-bridge"

export const legacyCheckoutMessage = (variantId: string, trackingId: string) => ({ variantId, trackingId })

let latestTrackingId: string | undefined

export const sendCheckoutStart = (variantId: string, trackingId: string, bridge?: NativeBridge, onSettled?: () => void): boolean => {
  if (!isAppBridgeAvailable()) return false

  if (bridge?.available) {
    latestTrackingId = trackingId
    const settle = () => {
      if (latestTrackingId === trackingId) onSettled?.()
    }
    void bridge.request("checkout.start", { variantId, trackingId }).then(settle, settle)
  } else {
    postToNativeHost(createNotification("checkout.start", { variantId, trackingId }))
  }
  postRawToNativeHost(legacyCheckoutMessage(variantId, trackingId))

  return true
}
